/* eslint-disable arrow-parens */
import React, { Component } from 'react';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';
import { Card, CardHeader } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import { database } from '../../utils/configureFirebase';
import CorporateConnectCard from '../../components/CorporateConnectCard';
import corporateConnectcsv from '../../utils/CorporateConnectCSV';

const ContentWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  margin-top: 16px;

  & > * + * {
    margin-top: 16px;
  }
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const ActionContaier = styled.div`
  margin-bottom: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

class EarlyBirdCorporateConnect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      registrations: undefined,
      isLoading: true,
    };
  }
  componentDidMount() {
    this.registrationRef = database.ref('contact/register');
    this.registrationRef.on('value', this.setRegistrationData);
  }

  setRegistrationData = snapshot => {
    if (snapshot) {
      const registrations = snapshot.val();
      if (registrations === null) {
        this.setState({
          registrations: undefined,
          isLoading: false,
        });
      } else {
        this.setState({
          registrations,
          isLoading: false,
        });
      }
    }
  };

  getRegistrations = registrations => {
    if (typeof registrations !== 'undefined') {
      const corporateArr = Object.keys(registrations).map(corporateId => {
        const formattedData = this.formatRegistration(
          registrations[corporateId],
        );
        return {
          ...formattedData,
          corporateId,
        };
      });
      return orderBy(corporateArr, corporate => corporate.timestamp, 'desc');
    }

    return [];
  };

  formatRegistration = data => ({
    ...data,
    time: this.formattedDate(data.timestamp),
  });

  formattedDate = timestamp => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  };

  updateStatus = (corporateId, value) => {
    database
      .ref()
      .child(`contact/register/${corporateId}`)
      .update({ status: !value });
  };

  updateComment = (corporateId, value) => {
    database
      .ref()
      .child(`contact/register/${corporateId}`)
      .update({ comment: value });
  };

  render() {
    const { registrations, isLoading } = this.state;

    const corporateRegistrations = this.getRegistrations(registrations);
    return (
      <div>
        {isLoading ? (
          <ContentContainer>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentContainer>
        ) : (
          <div>
            {registrations ? (
              <ContentWrapper>
                <ActionContaier>
                  <ButtonContainer>
                    <RaisedButton
                      label="Download"
                      primary
                      onTouchTap={() => {
                        corporateConnectcsv(corporateRegistrations);
                      }}
                    />
                  </ButtonContainer>
                </ActionContaier>
                <ContentContainer>
                  {corporateRegistrations.map(corporate => (
                    <CorporateConnectCard
                      {...corporate}
                      key={corporate.corporateId}
                      updateStatus={this.updateStatus}
                      updateComment={this.updateComment}
                    />
                  ))}
                </ContentContainer>
              </ContentWrapper>
            ) : (
              <ContentWrapper>
                <Card>
                  <CardHeader title="No registrations found" />
                </Card>
              </ContentWrapper>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default EarlyBirdCorporateConnect;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCorporateConnect/EarlyBirdCorporateConnect.js